/**
  * this create remove broken image effect
**/
import $ from 'jquery';

export	function removeBrokenImage(){

	$(window).bind('load', function() {
		$('img').each(function() {
    			if((typeof this.naturalWidth != "undefined" && this.naturalWidth == 0 ) || this.readyState == 'uninitialized' ) {
				$(this).addClass('hideItem');
		    	}	
		}); 
	});
		
}
